import _metadataHelper from "./metadata.js";
import _metadataKeys from "../../dict/metadataKeys.js";
import _formats from "../../lib/formats.js";
const formats = _formats;
const metadataKeys = _metadataKeys;
const metadataHelper = _metadataHelper;
function getEncodeOptionDefs(profileName) {
  const title = formats.getProfileTitleByName(profileName);
  if (typeof title !== "string") {
    return [];
  }
  return formats.profileMapping[title]?.options?.encode || [];
}

/* Replace encoding options set to "auto" with the matching Event Group metadata value.
   If no (valid) metadata value exists, fall back to the default from formats.js, and if there is no default the option is dropped so the encoder uses its own fallback.
   Options that have no metadata mapping (eg. Scenarist "Timecode Format") keep "auto" because it has a format specific meaning.
   Returns a new array - the input is never mutated. */
export default (function resolveAutoOptions(formatOptions, eventGroup, profileName) {
  if (!Array.isArray(formatOptions) || formatOptions.length === 0) {
    return formatOptions;
  }
  const optionDefs = getEncodeOptionDefs(profileName);
  const resolved = [];
  formatOptions.forEach(option => {
    const mapping = option && metadataKeys.optionMap[option.name];
    if (!mapping || option.selected !== "auto") {
      resolved.push(option);
      return;
    }

    /* Some mappings only apply to certain profiles (eg. units differ) - other profiles go straight to the default */
    const usesMetadata = !mapping.profiles || mapping.profiles.includes(profileName);
    const optionDef = optionDefs.find(def => def.name === option.name);
    let value = usesMetadata ? metadataHelper.getMetadata(eventGroup, mapping.key) : undefined;
    if (value !== undefined && mapping.toOption) {
      value = mapping.toOption(value, optionDef);
    }
    if (value === undefined || value === null || value === "") {
      value = optionDef ? optionDef.selected : undefined;
    }
    if (value !== undefined && value !== "auto") {
      resolved.push({
        ...option,
        selected: value
      });
    }
  });
  return resolved;
});